import React, { useEffect } from "react";
import '../../Styles/HomePage.scss'
// import { useAuth0 } from "@auth0/auth0-react";
import { useUser } from '@clerk/react'

const Profile = () => {
  // const { user, isAuthenticated, isLoading } = useAuth0();
  const { isLoaded, isSignedIn, user } = useUser()

  // useEffect(() => {
  //   if (user) {
  //     localStorage.setItem("userRentEasy", JSON.stringify(user));
  //   }
  // }, [user]);

  if (!isLoaded) {
    return <div>Loading ...</div>;
  }

  return (
    isSignedIn && (
      <div>
        <span style={{display:"flex", gap:"10px"}}>
          <img src={user?.imageUrl} alt={user.fullName} className='user-img' />
        </span>
      </div>
    )
  );
};

export default Profile;


